import React, { Component } from "react";
import Page from "../../containers/page";
import xIcon from '../../assets/svg/x.svg';

import {
    Container,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Table,
    Input,
    FormGroup,
    Label,
    Button,
} from "reactstrap";

import Isvg from "react-inlinesvg";

import { Player, Controls } from '@lottiefiles/react-lottie-player';

import FormBuilder from "../../components/forms/modalFormBuilder";
import { required } from "../../components/forms/validation";
import ErrorModal from '../../components/errorModal';
import InfoModal from '../../components/infoModal';
import ListBuilder from "../../components/listBuilder";
import DeleteModal from "../../components/deleteModal";
import {
    getSearchParams,
    generateSearchLink,
    generateSearchLinkMultiple,
} from "../../helpers/linkHelper";
import { API_ENDPOINT, DOMAINS, getAgeLimit } from "../../constants";
import { formValueSelector, change } from "redux-form"; // ES6
import { connect } from "react-redux";
import ClinicsFilter from "../../components/clinicsFilter";
import UsersFilter from "../../components/usersFilter";
import Image from "../../components/forms/fields/image";
import Zip from "../../components/forms/fields/zip";


import edit from "../../assets/svg/edit.svg";
import garabage from "../../assets/svg/garbage.svg";
import ehrIcon from "../../assets/svg/export-ehr.svg";
import attachInvoice from '../../assets/svg/attach.svg'

import addIcon from "../../assets/svg/add-icon.svg";
import webdocImage from "../../assets/images/webdoc.png";
import teleqImage from "../../assets/images/teleqLogo.png";
import sembleImage from "../../assets/images/semble.webp";
import labPortalenImage from '../../assets/images/Labportalen_logo.png';

import takeCareImage from '../../assets/images/take_care.webp';
import Search from "../../components/search";
import profileUser from "../../assets/images/user.png";
import notification from "../../assets/svg/notification.svg";
import Usage from "../../assets/svg/usage.svg";
import importIcon from '../../assets/svg/import.svg'

import exportIcon from "../../assets/svg/export.svg";
import Checkbox from '../../components/forms/fields/checkbox';
import MainClicGroupFilter from '../../components/mainClinicGroupsFilter';
import striptags from "striptags";

import downloadIcon from '../../assets/svg/download.svg';

import axios from 'axios'


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

class ClinicGroupsExportComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,

        }
    }

    getExportGroupData = () => {
        const groupId = this.props.groupId;
        if (!groupId) return;

        const token = typeof localStorage !== "undefined" ? localStorage.getItem("authToken") : null;

        const obj = {
            groupId
        }

        fetch(API_ENDPOINT + "/data/clinic-groups/export-data/get", {
            method: "POST",
            headers: {
                Authorization: token ? `Bearer ${token}` : null,
                "content-type": "application/json",
            },
            body: JSON.stringify(obj),
        }).then(parseJSON).then(({ result, status }) => {
            const groupData = result?.groupData;
            const clinicGroupsExports = result?.clinicGroupsExports || [];

            this.setState({ groupData, clinicGroupsExports })

            const hasRunningExport = clinicGroupsExports?.some(exportItem => !exportItem?.finished);

            if (hasRunningExport) {
                if (this.interval) clearInterval(this.interval);
                this.interval = setInterval(() => {
                    this.getExportGroupData();
                }, 3000);
            }
        })

    }

    setInitialData = () => {
        this.getExportGroupData();
    }




    componentDidMount() {
        this.setInitialData();



    }
    componentDidUpdate(prevProps, prevState) {


    }
    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);
    }

    toggle = (callback = null) => {
        if (this.props.toggle) {
            this.props.toggle(callback);
        }

    }


    export = () => {
        if (this.state?.exportButtonLoading) return;
        const groupId = this.props.groupId;
        if (!groupId) return;

        const token = typeof localStorage !== "undefined" ? localStorage.getItem("authToken") : null;

        const obj = {
            groupId
        }

        this.setState({ exportButtonLoading: true }, () => {
            fetch(API_ENDPOINT + "/data/clinic-groups/export-data/run", {
                method: "POST",
                headers: {
                    Authorization: token ? `Bearer ${token}` : null,
                    "content-type": "application/json",
                },
                body: JSON.stringify(obj),
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ exportButtonLoading: false })
                this.getExportGroupData();
            })
        })
    }


    render() {
        const isOpen = this.props.groupId ? true : false;

        const { groupData, clinicGroupsExports } = this.state || {};
        if (!groupData) return null;

        let logs = this.state?.showLogs ? clinicGroupsExports?.find(exportItem => exportItem._id === this.state.showLogs)?.log?.reverse() : null;
        const logsNotFinished = this.state?.showLogs && !clinicGroupsExports?.find(exportItem => exportItem._id === this.state.showLogs)?.finished;
        return (
            <>

                <Modal isOpen={isOpen} centered size="lg">
                    <ModalHeader toggle={() => this.toggle()}
                        close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>}>
                        {'Export clinic group'.translate(this.props.lang)}
                    </ModalHeader>

                    <ModalBody>
                        <div className="clinic-group-export-modal-wrap">
                            <div className="clinic-group-exported-data-wrap">
                                {!clinicGroupsExports?.length ?
                                    <div className="no-exports">
                                        <p>{'No exports yet'.translate(this.props.lang)}</p>
                                    </div>
                                    :
                                    <div className="clinic-group-exported-data">
                                        {clinicGroupsExports?.map((exportItem, index) => {
                                            const folderName = exportItem?.folderName;
                                            const startTime = exportItem?.tsStart ? this.props.getStringDateTs(exportItem.tsStart, this.props.dateFormat + ' HH:mm') : null;
                                            const finishedTime = exportItem?.finishedTs ? this.props.getStringDateTs(exportItem.finishedTs, this.props.dateFormat + ' HH:mm') : null;
                                            const userName = exportItem?.user?.username;
                                            const isFinished = exportItem?.finished;
                                            const isFailed = exportItem?.failed;
                                            const zipFilePath = exportItem?.zipFilePath;
                                            const folderSize = exportItem?.folderSize ?? null;
                                            const zipSize = exportItem?.zipSize ?? null;

                                            return (
                                                <div key={index} className="clinic-group-exported-data-item">
                                                    <div className="clinic-group-exported-data-item-left">
                                                        <div>{folderName}</div>
                                                        <div style={{ fontSize: 14, color: '#aaa' }}>{'Started by'.translate(this.props.lang)}: {userName} </div>
                                                        <div style={{ fontSize: 14, color: '#aaa' }}>{startTime ? `Started at: ${startTime}` : null}</div>
                                                        <div style={{ fontSize: 14, color: '#aaa' }}>{isFinished ? `Finished at: ${finishedTime}` : 'Export in progress...'.translate(this.props.lang)}</div>
                                                        {isFailed && <div style={{ fontSize: 14, color: 'red' }}>{'Export failed'.translate(this.props.lang)}</div>}
                                                        {folderSize && <div style={{ fontSize: 14, color: '#aaa' }}>{`Folder size: ${folderSize}`}</div>}
                                                        {zipSize && <div style={{ fontSize: 14, color: '#aaa' }}>{`Zip size: ${zipSize}`}</div>}
                                                    </div>
                                                    <div className="clinic-group-exported-data-item-right">
                                                        <Button color='primary' onClick={() => { this.setState({ showLogs: exportItem?._id }) }}>
                                                            {'View log'.translate(this.props.lang)}
                                                        </Button>
                                                        <Button color={isFailed ? "danger" : "primary"} disabled={!zipFilePath} onClick={() => {
                                                            if (!zipFilePath) return;
                                                            var link = document.createElement("a");
                                                            link.download = `${zipFilePath}`;
                                                            link.target = "_blank";

                                                            // Construct the URI
                                                            link.href = API_ENDPOINT + `${zipFilePath}`;
                                                            document.body.appendChild(link);
                                                            link.click();

                                                        }}>
                                                            {zipFilePath || (isFinished && !isFailed) ? 'Download'.translate(this.props.lang) : isFailed ? 'Export failed'.translate(this.props.lang) : 'Exporting...'.translate(this.props.lang)}
                                                        </Button>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                }
                            </div>
                        </div>

                    </ModalBody>
                    <ModalFooter className="buttons-right-blue event-meetings-modal-footer-wrap ">
                        <Button style={{ minWidth: 100 }} color="primary" onClick={() => this.toggle()} >
                            {'Close'.translate(this.props.lang)}
                        </Button>
                        <Button style={{ minWidth: 100 }} disabled={this.state?.exportButtonLoading} color="primary" onClick={() => this.export()} >
                            {'Export data'.translate(this.props.lang)}
                        </Button>
                    </ModalFooter>
                </Modal>

                {
                    this.state.showLogs ?
                        <Modal isOpen={isOpen} centered size="lg">
                            <ModalHeader toggle={() => this.setState({ showLogs: null })}
                                close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ showLogs: null })}>&times;</button>}>
                                {'Export log'.translate(this.props.lang)}
                            </ModalHeader>

                            <ModalBody>
                                <div className="clinic-group-export-log-wrap">
                                    {!logs?.length ?
                                        <div className="no-logs">
                                            <p>{'No logs available'.translate(this.props.lang)}</p>
                                        </div>
                                        :
                                        <div className="clinic-group-export-log" style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                                            {
                                                logsNotFinished ?
                                                    <div className="loader-wrap">
                                                        <Player
                                                            autoplay={true}
                                                            loop={true}
                                                            renderer={'svg'}
                                                            src="/lf30_editor_l5cxzdyf.json"
                                                            style={{ height: "80px", width: "80px" }}
                                                        ></Player>
                                                    </div>
                                                    :
                                                    null
                                            }
                                            {logs.map((logItem, index) => {
                                                const error = logItem?.error;
                                                const details = logItem?.details;
                                                const logMessage = logItem?.message;
                                                const duration = logItem?.duration;
                                                const itemsCount = logItem?.itemsCount > 0 ? `, items: ${logItem.itemsCount}` : '';
                                                return (
                                                    <div key={index} className="clinic-group-export-log-item" style={{ borderBottom: index !== logs.length - 1 ? '1px solid #ccc' : 'none' }}>
                                                        <div style={{ fontWeight: 500 }}>{logMessage}{itemsCount}</div>
                                                        {
                                                            duration ?
                                                                <div style={{ fontSize: 14, color: '#aaa' }}>Duration: {duration ? `${duration}` : 'N/A'}</div>
                                                                : null
                                                        }
                                                        {error && details && <div style={{ marginTop: 10, color: 'red' }}>Error: {details}</div>}
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    }
                                </div>

                            </ModalBody>
                            <ModalFooter className="buttons-right-blue event-meetings-modal-footer-wrap ">
                                <Button style={{ minWidth: 100 }} color="primary" onClick={() => this.setState({ showLogs: null })} >
                                    {'Close'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }



            </>


        )
    }
}

export default ClinicGroupsExportComponent;